/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _slicedToArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import SearchBar from '@/components/SearchBar';
import { getKnowledgeFaqListPC, getKnowledgeFaqTypePC } from '@/api';
import SmyDatetimeRange from '@/components/SmyDatetimeRange';
import CheckUser from '@/components/CheckUser';
export default {
  name: 'FAQ',
  components: {
    ViewBox: ViewBox,
    Cell: Cell,
    PopupPicker: PopupPicker,
    Group: Group,
    SmyDatetimeRange: SmyDatetimeRange,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    SearchBar: SearchBar,
    CheckUser: CheckUser
  },
  data: function data() {
    return {
      serviceTypeList: [],
      parentList: [],
      parentId: '',
      searchForm: {
        name: ''
      },
      params: {
        pageIndex: 0,
        pageSize: 10,
        name: '',
        categaryId: 0
      },
      typeList: [],
      typeName: -1,
      total: 0,
      list: [],
      count: 0,
      checkUserModal: false
    };
  },
  watch: {
    parentId: function parentId(val) {
      this.loadType(val);
      this.params.categaryId = val;
      this.onPulldownLoading(true);
    }
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      // eslint-disable-next-line
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    },
    hasMore: function hasMore() {
      return this.list.length < this.count;
    }
  },
  methods: {
    search: function search() {
      this.onPulldownLoading();
    },
    changeParent: function changeParent(index, id) {
      this.parentList = this.parentList.slice(0, index + 1);
      this.parentId = id;
    },
    toggleParent: function toggleParent(id, parentId, v) {
      this.parentList.push(v);
      this.parentId = id;
    },
    onPulldownLoading: function onPulldownLoading() {
      var _this = this;
      this.params.pageIndex = 0;
      getKnowledgeFaqListPC(this.params).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          res = _ref2[0],
          count = _ref2[1];
        if (res.success) {
          _this.count = count.data;
          _this.list = res.data;
        }
        _this.$refs['orderList'] && _this.$refs['orderList'].enablePullup();
        if (_this.hasMore) {
          _this.$refs['orderList'] && _this.$refs['orderList'].donePullup();
        } else {
          _this.$refs['orderList'] && _this.$refs['orderList'].disablePullup();
        }
        _this.$refs['orderList'] && _this.$refs['orderList'].donePulldown();
      });
    },
    onPullupLoading: function onPullupLoading() {
      var _this2 = this;
      this.params.pageIndex++;
      getKnowledgeFaqListPC(this.params).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          res = _ref4[0],
          count = _ref4[1];
        if (res.success) {
          _this2.count = count.data;
          _this2.list = _this2.list.concat(res.data);
        }
        if (_this2.hasMore) {
          _this2.$refs['orderList'] && _this2.$refs['orderList'].donePullup();
        } else {
          _this2.$refs['orderList'] && _this2.$refs['orderList'].disablePullup();
        }
      });
    },
    refresh: function refresh() {
      this.onPulldownLoading();
    },
    reset: function reset() {
      this.params = {
        pageIndex: 0,
        pageSize: 10,
        keyword: '',
        categary_id: -1,
        start_time: '',
        end_time: '',
        user_id: '',
        user_name: i18n.tc("237")
      };
    },
    loadType: function loadType(parentId) {
      var _this3 = this;
      getKnowledgeFaqTypePC({
        parentId: parentId
      }).then(function (res) {
        if (res.success) {
          _this3.serviceTypeList = res.data.map(function (v) {
            return Object.assign(v, {
              parentId: v.fk_t_parent_id
            });
          });
        }
      });
    }
  },
  created: function created() {
    this.loadType(0);
    this.refresh();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.checkUserModal) {
      this.checkUserModal = !this.checkUserModal;
    } else {
      next();
    }
  }
};